<template>
    <b-row
        class="notification-wrapper"
        v-if="notification_queue.length"
        >
        <b-col
            :cols="16"
            :sm="16"
            :md="10"
            :lg="8"
            :xl="8"
            >
            <b-alert
                :variant="value.color"
                v-for="(value, key, index) in notification_queue"
                :key="index"
                @click="value.life = 0"
                :show="value.life > 0"
                dismissible
                >
                {{ value.text }}
            </b-alert>
        </b-col>
    </b-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
        }
    },
    computed: {
        ...mapGetters([
            'notification_queue',
        ])
    },
    methods: {
    },
    mounted() {
//        const params = new URLSearchParams(location.search)
//        let error = null
//        if ((error = params.get('error'))) {
//            this.$store.dispatch(
//                'notification/push',
//                {
//                    text: error,
//                    color: 'danger',
//                }
//            )
//        }
//
//        window.setInterval(() => {
//            this.processFlashes()
//        }, 100)
    },
}
</script>

<style scoped>
.notification-wrapper {
    position: fixed;
    top: 1em;
    width: 50%;
    text-align: left;
    z-index: 2000;
}
.notification-wrapper .alert {
    margin-left: 1em;
    cursor: pointer;
}
</style>

